// extracted by mini-css-extract-plugin
export var backdropBlur = "_mm-0";
export var contentCard = "_mm-5";
export var frame = "_mm-2";
export var image = "_mm-4";
export var imagePane = "_mm-3";
export var modal = "_mm-1";